import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=044a2906&scoped=true"
import script from "./UsersList.vue?vue&type=script&lang=ts"
export * from "./UsersList.vue?vue&type=script&lang=ts"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=044a2906&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a2906",
  null
  
)

export default component.exports